import { getId } from '@common/utils/brandDiffsUtils';
import { toggleCollection, toggleService } from '@state/features/storelocator.slice';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import StoreLocatorGeo from './StoreLocatorGeo';
const SERVICES_MONCLER = [
    'pickUpInStore',
    'clickAndReserve',
    'returnInStore',
    'bookAnAppointment',
    'exchangeInStore',
    'distantSale',
    'clickFromStore',
    'GarmentKit',
    'personalizationRoom',
];
const SERVICES_STONE = ['pickUpInStore', 'clickAndReserve', 'returnInStore', 'bookAnAppointment', 'exchangeInStore', 'clickFromStore'];
const COLLECTIONS_MONCLER = ['men', 'women', 'children'];
const COLLECTIONS_STONE = ['men', 'junior', 'collaboration'];
const COLLECTIONSCODES_MONCLER = ['01', '02', '03'];
const COLLECTIONSCODES_STONE = ['01', '02', '03'];
const SERVICES = {
    MO: SERVICES_MONCLER,
    ST: SERVICES_STONE,
};
const COLLECTIONS = {
    MO: COLLECTIONS_MONCLER,
    ST: COLLECTIONS_STONE,
};
const COLLECTIONSCODES = {
    MO: COLLECTIONSCODES_MONCLER,
    ST: COLLECTIONSCODES_STONE,
};
const StoreLocatorFilters = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { filters } = useSelector((state) => state.storelocator);
    const isCollectionSelected = (collection) => {
        return filters.collections.find((el) => el === collection);
    };
    const isServiceSelected = (serviceItem) => {
        return filters.services.find((service) => service === serviceItem);
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", { className: "search-store__filters", id: "refineOptions", onKeyDown: (e) => {
            if (e.key == 'Escape') {
                e.preventDefault();
                props.close();
            }
        } },
        React.createElement("div", { className: "search-store__filters__container" },
            React.createElement("ul", { className: "storelocator-filters", "aria-label": t('storelocator.refinemenu.label') },
                COLLECTIONS[getId()].map((col, i) => (React.createElement("li", { key: i },
                    React.createElement("input", { type: "checkbox", checked: isCollectionSelected(COLLECTIONSCODES[getId()][i]) ? true : false, onChange: () => {
                            dispatch(toggleCollection(COLLECTIONSCODES[getId()][i]));
                        }, id: 'filter-collection-' + i }),
                    React.createElement("label", { htmlFor: 'filter-collection-' + i }, t(`storelocator.${col}`))))),
                SERVICES[getId()].map((service, i) => (React.createElement("li", { key: i },
                    React.createElement("input", { type: "checkbox", checked: isServiceSelected(service) ? true : false, onChange: () => {
                            dispatch(toggleService(service));
                        }, id: 'filter-service-' + i }),
                    React.createElement("label", { htmlFor: 'filter-service-' + i }, t(`storelocator.${service}`)))))),
            getId() === 'ST' && React.createElement(StoreLocatorGeo, null))));
};
export default StoreLocatorFilters;
